jQuery(document).on('turbolinks:load', () => {
  jQuery(document).on('click', '.custom-dropdown.keep-open .dropdown-menu', function (e) {
    e.stopPropagation();
  });
});